<template>
  <div class="patient-info-container">
    <div class="patient-info-content">
      <div class="title-container"> 
        <b-button class="btn-back" variant="info" @click="goBack">
          <i class="wizard-icon ti-arrow-circle-left" />
        </b-button>
        <h3 class="sidebar-title">Detalles {{foodDetails && !isSearching ? foodDetails.name : ""}}</h3>
      </div>
      <div v-if="foodDetails && !isSearching">
        <h6 class="patient-info-title"> Macronutrientes </h6>
        <div class="row ml-1">
          <p class="col-6 patient-info-data">
            <span>- Proteína: </span>
          </p>
          <p class="col-6 patient-info-data">
            <span v-if="foodDetails.protein_grams">{{foodDetails.protein_grams}} gr</span>
            <span v-else>0 gr</span>
          </p>
          <p class="col-6 patient-info-data">
            <span>- Lípidos:</span>
          </p>
          <p class="col-6 patient-info-data">
            <span v-if="foodDetails.lipid_grams">{{foodDetails.lipid_grams}} gr</span>
            <span v-else>0 gr</span>
          </p>
          <p class="col-6 patient-info-data">
            <span>- CHO: </span>
          </p>
          <p class="col-6 patient-info-data">
            <span v-if="foodDetails.cho_grams">{{foodDetails.cho_grams}} gr</span>
            <span v-else>0 gr</span>
          </p>
        </div>
        <h6 class="patient-info-title"> Porciones </h6>
        <p class="patient-info-data mt-1">
          <ul class="dashed">
            <li v-for="(food, index) in foodDetails.foods"
              class="rich-text"
              :key="index"
            >{{food.name}}: {{food.portion_quantity}}</li>
          </ul>
        </p>
      </div>
      <div class="spinner-space" v-else>
        <SpinnerBackdrop thickness="0.2rem" variant="info"/>
      </div>
    </div>
  </div>
</template>

<script>
import SpinnerBackdrop from '../../SpinnerBackdrop'

export default {
  name: "FoodDetails",
  components: {
    SpinnerBackdrop
  },
  props: {
    foodDetails: {
      type: Object,
      default: function(){
        return {
          name: "",
          foods: []
        };
      },
    },
    isSearching: {
      type: Boolean,
      default: true
    }
  },
  data: function() {
    return {
    };
  },
  computed: {
  },
  methods: {
    goBack () {
      this.$emit("hide-details")
    }
  },
  watch: {
    
  },
};
</script>

<style scoped lang="scss">
li.rich-text {
  white-space: pre-wrap;
}

.patient-info-container {
  display: flex;
  flex-direction: column;
  height: 100%;
}

.patient-info-content {
  flex-grow: 1;
  overflow-y: auto;
  overflow-x: hidden;
  max-height: 100%;
}

.patient-info-button-container {
  padding-top: 1rem;
}

.patient-info-title {
  margin-top: 1.25rem;
  margin-bottom: 0.6rem;
  font-size: $font-size-sm;
}

.patient-info-data {
  padding-top: 0.25rem;
  padding-bottom: 0.1rem;
  margin: 0;
  line-height: 1.2;
  font-size: $font-size-sm;
}

.patient-info-separator {
  margin: 2rem 0;
  height: 0;
  background-color: $gray-300;
}
ul {
  margin: 0;
}
ul.dashed {
  list-style-type: none;
  padding-left: 15px;
}
ul.dashed > li:before {
  content: "- ";
}
.spinner-space {
  position: static;
  width: 100%;
  height: 20%;
}

.btn-back {
  display: flex;
  justify-content: center;
  align-items: center;
  width: 2.5rem;
  height: 2.5rem;
  line-height: 1.2;
  border-radius: 50%;
  padding: 0;
  font-size: 2.1rem;

  & i {
    width: 100%;
    height: 100%;
  }
  
  &:disabled {
    cursor: default !important;
  }
}
.title-container {
  display: flex;
  flex-flow: row nowrap;
  align-items: center;
  justify-content: space-evenly;
}
.sidebar-title {
  margin-bottom: 0px;
  margin-top: 2px;
  padding-left: 4px;
}
</style>